import getConditionDescriptionPart from '@/screens/workflows/lib/getConditionDescriptionPart';
import { isObject } from '@shared/utils/isObject';

const isPrimitive = (n) => typeof n !== 'object' && n !== null;

const parseError = (value) => {
  if (isObject(value)) {
    if (value?.type === 'lexical') {
      return getConditionDescriptionPart({ value })?.content;
    }

    return JSON.stringify(value);
  }

  if (isPrimitive(value)) {
    return value;
  }

  return JSON.stringify(value);
};

export default parseError;
